module.exports = __webpack_public_path__ + "img/activity12.c3f0fdfb.jpg";